import React, { useState, useEffect, useContext, useCallback } from 'react'
import Swal from 'sweetalert2';
import { deleteAddressById, getAddress, postAddress, putAddress } from '../api/address';
import { getCityByStateId, getStateByCountryId } from '../api/countries';
import { AuthContext } from '../context/AuthContext';

export const useAddress = () => {
  const [countryId, setCountryId] = useState('484');
  const [countryStates, setCountryStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [stateIdent, setStateIdent] = ('')

  const { setLoading,checkToken } = useContext(AuthContext);
  const [addresses, setAddresses] = useState([]);

  const getAddresses = async () => {
    checkToken()
    try {
      setLoading(true)
      const { data } = await getAddress();
      setLoading(false)
      setAddresses([...data.data]);
      return
    } catch (e) {
      setLoading(false)
      setAddresses([]);
      if (e.response.data.code != "NOT_FOUND") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      };
    }
  }

  const deleteAddress = async (addressId) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await deleteAddressById(addressId);
      setLoading(false);
      setAddresses(addresses.filter(address => address.address.id != addressId))
      return (true)
    }
    catch (e) {
      setLoading(false);
      ////console.log(e.response?._response);
      return (false)
    }
  }

  const createAddress = async (data) => {
    checkToken()
    try {
      setLoading(true);
      const { dataa } = await postAddress(data);
      ////console.log(data)
      setLoading(false);
      return true
    } catch (e) {
      console.log(e)
      setLoading(false);
      return false
    }
  }

  const editAddress = async (data) => {
    checkToken()
    try {
      setLoading(true);
      const { dataa } = await putAddress(data);
      ////console.log(data)
      setLoading(false);
      return true
    } catch (e) {
      console.log(e)
      setLoading(false);
      return false
    }
  }


  const handleCities = async (stateId) => {
    checkToken()
    try {
      setLoading(true);
      if (stateId !== 0) {
        const { data } = await getCityByStateId(countryId, stateId);
        ////console.log(data.data)
        setCities(data.data);
      }
      setLoading(false);
      return true;
    } catch (e) {
      setLoading(false);
      setCities([]);
      //console.log(e.request?._response);
    }
  }

  const handleOnChangeCountry = useCallback(async (e) => {
    if (e !== 0) {
      setCountryId(e);

      setLoading(true);
      await getStateByCountryId(e)
        .then(({ data }) => {
          //console.log(data.data)
          setCountryStates(data.data);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setLoading(false);
        });
      return;
    }
  }, [countryId])

  return {
    getAddresses,
    editAddress,
    handleOnChangeCountry,
    handleCities,
    setAddresses,
    createAddress,
    addresses,
    deleteAddress,
    countryStates,
    cities,
    countryId
  }
}